import { render, staticRenderFns } from "./member-input.vue?vue&type=template&id=524b29d3&scoped=true&lang=pug"
import script from "./member-input.vue?vue&type=script&lang=js"
export * from "./member-input.vue?vue&type=script&lang=js"
import style0 from "./member-input.vue?vue&type=style&index=0&id=524b29d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524b29d3",
  null
  
)

export default component.exports